var CrudCandidat = function() {
    'use strict';

    var $selectTypeDepotDossier;

    function initBirthdayField() {
        var $inputDateNaissance = $('#date-naissance');
        $inputDateNaissance.datepicker({
            startView: $inputDateNaissance.val() ? 'days' : 'decades',
        });

        $inputDateNaissance.on('change', function(e) {
            $inputDateNaissance.datepicker('destroy').datepicker({
                startView : e.target.value ? 'days' : 'decades',
            });
        });
    }

    function initConseiller() {
        var $filterConseiller = $('#filterConseiller');
        if($filterConseiller.length) {
            $filterConseiller.select2({
                minimumResultsForSearch: 3,
                placeholder: 'Conseiller',
                allowClear: true,
                dropdownAutoWidth: true,
            });
            $('.select2-container').addClass('form-control');
        }

        $('#filterConseillerInfo').on('click', function(e) {
            e.preventDefault();
            $("#filterConseillerInfoContent").toggleClass('d-none');
        });

    }

    function init() {
        $selectTypeDepotDossier = $('#type-depot-dossier');

        initBirthdayField();
        initConseiller();

        // Initialisation des 'select2'
        $selectTypeDepotDossier.select2();
    }

    return {
        init: init,
    };

}();
